export class FollowOnRoundDTO {
  cost: number;
  fmv: number;
  holding: number;
  preMoney: number;
  totalRound: number;
  postMoney: number;
  exitValue: number;
  exitProbability: number;
  uuid: string;
  multiple: number;
  riskProb: number;
  roundDate: Date;
  iconNameAndStylingLeft: string;
}
